<template>
    <div class="notification-filters">
        <div class="stats-inline">
            <span class="stats-total"
                >전체 <strong>{{ totalCount }}</strong
                >건</span
            >
            <span v-if="unreadCount > 0" class="stats-item">
                <span class="stats-sep">|</span>
                <span class="stats-unread"
                    >안읽음 <strong>{{ unreadCount }}</strong
                    >건</span
                >
            </span>
        </div>
        <div class="filter-actions">
            <select v-model="localUnreadOnly" class="filter-select" @change="emitApply">
                <option :value="false">전체</option>
                <option :value="true">안읽음만</option>
            </select>
            <button type="button" class="btn-apply btn-primary" @click="emitApply">
                <i class="fas fa-search"></i> 조회
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotificationFilters",
    props: {
        unreadOnly: { type: Boolean, default: false },
        totalCount: { type: Number, default: 0 },
        unreadCount: { type: Number, default: 0 },
    },
    data() {
        return {
            localUnreadOnly: this.unreadOnly,
        };
    },
    watch: {
        unreadOnly(v) {
            this.localUnreadOnly = v;
        },
    },
    methods: {
        emitApply() {
            this.$emit("apply", { unreadOnly: this.localUnreadOnly });
        },
    },
};
</script>

<style scoped>
.notification-filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 10px;
}

.stats-inline {
    font-size: 13px;
    color: #64748b;
}

.stats-inline strong {
    color: #1e293b;
    font-weight: 600;
}

.stats-item {
    display: inline;
}

.stats-sep {
    margin: 0 8px;
    color: #cbd5e1;
}

.stats-unread {
    margin-right: 4px;
}

.filter-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.filter-label {
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
}

.filter-select {
    padding: 6px 10px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 13px;
    min-width: 120px;
}

.btn-apply {
    padding: 6px 12px;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    background: #ffffff;
    color: #64748b;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
}
.btn-apply:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-primary {
    background: #52b788;
    color: #ffffff;
    border-color: #52b788;
}

.btn-primary:hover:not(:disabled) {
    background: #2d8659;
    border-color: #2d8659;
}
</style>
